import { useState } from 'react';
import { Link } from 'react-router-dom';
import { resetPasswordEmail } from '../services/AuthService';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setLoading(true);

    try {
      await resetPasswordEmail({ email:email });
      setSuccess('Password reset instructions sent to your email!');
      setEmail('');
      setTimeout(() => setSuccess(null), 5000);
    } catch (err) {
      setError(`An error occurred. ${err.message} Please try again.`);
      console.error('Password reset failed:', err);
      setTimeout(() => setError(null), 5000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <header className="bg-gradient-to-r from-purple-600 to-blue-600 py-6 -mx-8 -mt-8 rounded-t-lg">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-4xl font-bold text-white">Forgot Password</h1>
            <p className="mt-2 text-lg text-indigo-50">Reset Your SendFalcon Account</p>
          </div>
        </header>
        <div className="mt-6">
          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
              {error}
            </div>
          )}
          {success && (
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
              {success}
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-xl text-gray-800">
                Email Address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1 block w-full text-md px-3 py-2 border border-gray-400 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 placeholder:text-lg placeholder:text-gray-400"
                placeholder="you@example.com"
                style={{ fontSize: '1.15rem' }}
              />
            </div>
            <div>
              <button
                type="submit"
                className={`w-full text-xl flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white cursor-pointer ${
                  loading ? 'bg-indigo-400 cursor-not-allowed' : 'bg-indigo-500 hover:bg-indigo-600'
                } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}
                disabled={loading}
              >
                {loading ? 'Sending...' : 'Send Reset Instructions'}
              </button>
            </div>
          </form>
          <p className="mt-4 text-center text-gray-700">
            Back to{' '}
            <Link to="/login" className="font-medium text-indigo-500 hover:text-indigo-600">
              Login
            </Link>
          </p>
        </div>
      </div>
      <div className="absolute bottom-2 w-full text-center py-4">
        <p className="text-base">© 2025 SendFalcon. All rights reserved.</p>
      </div>
    </div>
  );
}
